import { Heading } from "@/components/heading/Heading";
import { type Team } from "@repo/api";
import { Badge, ListView, ListViewItem, Text, peopleIcon } from "@repo/skapa";
import { T, t } from "@repo/translation";
import { ElementsContainer, SearchTeam, SectionContainer } from "@repo/ui";
import { hasItems, trackAnalytics } from "@repo/utils";

import {
  type ManageTeamState,
  type ManageTeamStateActions,
} from "./ManageTeamReducer";

interface Props {
  state: ManageTeamState;
  actions: ManageTeamStateActions;
}

export const SelectTeamStep = ({ state, actions }: Props) => {
  const onSelect = (team: Team) => {
    actions.setSelectedTeamId(team?.teamId);
    actions.setStep("DETAIL");
  };

  return (
    <SectionContainer>
      <SearchTeam onSelect={onSelect} />

      <ElementsContainer>
        <Heading textStyle="Heading.S">
          <T translationKey="label.my_teams" />
        </Heading>

        {hasItems(state.teams) ? (
          <ListView id="select-team-list">
            {state.teams.map((team) => (
              <ListViewItem
                key={team.teamId}
                leadingIcon={peopleIcon}
                onClick={() => {
                  onSelect(team);
                  trackAnalytics("open_team_details_modal");
                }}
                control="navigational"
                title={team.teamName}
                description={
                  team.description
                    ? `${team.description} | ${t("ID")}: ${team.teamId}`
                    : `${t("label.ID")}: ${team.teamId}`
                }
                addOn={
                  team.default ? (
                    <Badge
                      colour="blue"
                      label={t("label.default_team")}
                      size="small"
                    />
                  ) : undefined
                }
              />
            ))}
          </ListView>
        ) : (
          <Text>
            <T translationKey="prompt.no_team" />
          </Text>
        )}
      </ElementsContainer>
    </SectionContainer>
  );
};
